import $, { AxiosPromise } from 'axios';
import { ApiSecurity } from './apiSecurity';
import { GetURI } from './utilities';

const BASEURL = `${GetURI()}/api`;

interface DataConstructor {
    table?: string;
    query?: string | object;
    id?: string;
    insert?: boolean;
    command?: string;
}

export class ApiData {
    public query?: string | object;
    public tblName?: string;
    public id?: string;
    public insert?: boolean;
    public command?: string;

    constructor(data: DataConstructor) {
        if (data.table) {
            this.tblName = data.table;
        } else {
            this.tblName = '';
        }
        if (data.query) {
            this.query = data.query;
        } else {
            this.query = '';
        }
        if (data.id) {
            this.id = data.id;
        } else {
            this.id = '';
        }
        if (data.insert) {
            this.insert = true;
        }
        if (data.command) {
            this.command = data.command;
        }
    }

    public send(): AxiosPromise {
        let data = {};
        const headerVal = new ApiSecurity(
            '35b152372ba903bb39105e297ed148e9189184aea711e1d369cd9978a234807c',
            'f72c46b2193065134b2196f7c9522ad95a333eff211af101c43dadf74f1ee6a8.iovation.com',
        );
        data = Object.assign(data, { headers: { 'x-authentication': headerVal.get() } });
        if (this.tblName) {
            if (this.id) {
                data = Object.assign(data, { url: `${BASEURL}/${this.tblName}/${this.id}`, method: 'GET' });
            } else if (this.insert) {
                data = Object.assign(data, { url: `${BASEURL}/data/${this.tblName}`, method: 'POST', data: this.query });
            } else {
                data = Object.assign(data, { url: `${BASEURL}/data/${this.tblName}`, method: 'GET' });
            }
        } else if (this.command) {
            data = Object.assign(data, this.commandSelection());
            return $(data);
        } else {
            data = Object.assign(data, { url: `${BASEURL}/query`, method: 'POST', data: { query: this.query } });
        }
        return $(data);
    }

    private commandSelection(): object {
        let data = new Object();
        if (this.command) {
            switch (this.command.toLowerCase()) {
                case 'get_flow':
                    if (this.insert) {
                        data = Object.assign(data, { url: `${BASEURL}/flow/${this.id}`, method: 'POST', data: this.query });
                    } else {
                        data = Object.assign(data, { url: `${BASEURL}/flow/${this.id}`, method: 'GET' });
                    }
                    break;
                case 'get_module':
                    if (this.insert) {
                        data = Object.assign(data, { url: `${BASEURL}/module/${this.id}`, method: 'POST', data: this.query });
                    } else {
                        data = Object.assign(data, { url: `${BASEURL}/module/${this.id}`, method: 'GET' });
                    }
                    break;
                case 'get_field':
                    if (this.insert) {
                        data = Object.assign(data, { url: `${BASEURL}/field/${this.id}`, method: 'POST', data: this.query });
                    } else {
                        data = Object.assign(data, { url: `${BASEURL}/field/${this.id}`, method: 'GET' });
                    }
                    break;
                case 'get_rule':
                    if (this.insert) {
                        data = Object.assign(data, { url: `${BASEURL}/rule/${this.id}`, method: 'POST', data: this.query });
                    } else {
                        if (this.id) {
                            data = Object.assign(data, { url: `${BASEURL}/rule/${this.id}`, method: 'GET' });
                        } else {
                            data = Object.assign(data, { url: `${BASEURL}/rule`, method: 'GET' });
                        }
                    }
                    break;
            }
        }
        return data;
    }
}
